import { ProductBreadcrumbType } from 'types/ProductPageV2/Products';
import { Hierarchy } from 'types/Hierarchy';
import { formatMainName } from './formatter';

type AttributeDefinitionType = {
  AttributeDefinitionCode: string;
  Value: string;
  AttributeGlossaryId?: number | null;
  Metadata: {
    Label: string;
    Value: string;
  }[];
};

export function newHierarchy(url: string, label: string): Hierarchy {
  return {
    Description: '',
    Id: 0,
    Label: label,
    Metadata: [{ Label: '', Value: '' }],
    Url: url,
    __type: '',
    Children: [],
  };
}

export function newProductBreadCrumb(
  url: string,
  label: string
): ProductBreadcrumbType {
  return {
    Description: '',
    Id: 0,
    Label: label,
    Metadata: [],
    Url: url,
    __type: '',
    Children: [],
  };
}

export function getDataFromAttributes(
  dataAttributes:
    | {
        AttributeDefinitionCode: string;
        Value: string;
        AttributeGlossaryId?: number | null;
      }[]
    | undefined,
  generalAttributes: { [key: string]: { Label: string; MainName: string } }
): { [mainName: string]: string } {
  if (!dataAttributes || !Object.keys(generalAttributes).length) {
    return {};
  }
  return dataAttributes.reduce(
    (accumulator, attribute) => ({
      ...accumulator,
      [formatMainName(
        generalAttributes[attribute.AttributeDefinitionCode]?.MainName ??
          getSysName(generalAttributes[attribute.AttributeDefinitionCode])
      )]: attribute.Value,
    }),
    {}
  );
}

function getSysName(attributes?: AttributeDefinitionType): string | undefined {
  const { Metadata } = { ...attributes };
  return Metadata?.find(item => item.Label === 'SysName')?.Value;
}
